"use client"
import { act, useEffect, useRef, useState } from 'react';
// import useChat from '../hooks/useChat';
// import { io } from 'socket.io-client';
import useChat from '../../../providers/useChat';
import InputText from '@/components/Atoms/inputText';
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
import UsersAssociationSelect from '@/components/Atoms/Select/UsersAssociationSelect';
import UserSelect from '@/components/Atoms/Select/UserSelect';
import MessageSmallCard from './Social/MessageSmallCard';
import { humanizeString } from '@/utils/frontend/stringOps';
import NewMessageCard from './Social/NewMessageCard';
import { NewRecordButton, PlaneButton } from '@/components/Atoms/Buttons/ColorButtons';
import Link from 'next/link';
import { dateFormat_0, dateFormat_1, dateFormat_2, dateFormat_3, dateFormat_4 } from '@/utils/frontend/dateOps';
import { useRouter, useParams } from 'next/navigation';
import { getData } from '@/utils/frontend/dataOps';
// let socket;

export default function Chat({
  activeChat, callback, 
  // newChatRecipient={user_handle: 'talnetbotter', user_uuid: 'd543f3b1-7ab4-458c-8253-242bad117824'}
}) {
  const router = useRouter()
  const params = useParams()

  // console.log('activeChat', activeChat)
  const { messages, sendMessage, connected, joinChat } = useChat();
  const [newMessage, setNewMessage] = useState('');
    const { thisUser, error, setError, success, setSuccess } = useContext(UIContext);

  const [recipientsHandles, setRecipientsHandles] = useState([])
  const [recipientInput, setRecipientInput] = useState('')
  const [activeChatUUID, setActiveChatUUID] = useState(activeChat?.chat_uuid)
  const [activeChatParticipants, setActiveChatParticipants] = useState(activeChat?.participants)
  const [usersTable, setUsersTable] = useState([])
  const [loading, setLoading] = useState(false)
  const [followsMe, setFollowsMe] = useState([])
  const [followedByMe, setFollowedByMe] = useState([])
    const [charLimitError, setCharLimitError] = useState(false)
  const [charCount, setCharCount] = useState(0)

  const CHAR_LIMIT = 500
  // const [concatenatedMessages, setConcatenatedMessages] = useState([])
// let activeChatParticipants = activeChat?.participants || [];
  // let activeChatParticipants;


     const getFollowing = async () => { //(await cookies()).toString()
           const data = await getData(`social/follows?filter=true&user_profile_uuid=${thisUser?.user_uuid}&user_type=${thisUser?.user_type}`, undefined, 'include', undefined, undefined , 'getFollowing@chat')
          //  console.log('data@getFollowing', data)
           return data.data
     }


       useEffect(() => {
    const init = async () => {
     const following = await getFollowing()
     console.log("FOLLOWING", following)
     setFollowedByMe(await following?.[0].followed_by_me)
     setFollowsMe(await following?.[0].follows_me)
    }
    init()
  }, [])



  const handleKeyDown = (e) => {

      if (e.key === 'Enter' && !e.shiftKey) {

        e.preventDefault()
        handleSend()
        // if (!recipientInput.trim()) return

        // setRecipientsHandles(prev => [
        //   ...new Set([...prev, recipientInput.trim()])
        // ])

        // setRecipientInput('')
      }
}

  const handleSubmit = async ({chat_uuid}) => {


    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
    /*---------------------------------------
      PUT new message in submission events
    ---------------------------------------*/
        
    try {
        const response = await fetch(`${baseUrl}/api/chat/?user_type=${thisUser.user_type}`, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({data: {
               recipient_chat_users_handles: recipientsHandles,
               message: newMessage,
               chat_uuid: chat_uuid
          }, user: thisUser}) // Necessary for cookies if API is on the same domain
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("DATA@CHATRESPONSE", data)
        return data
        // setRecordsTable(data.data?.reverse());
        // setSubmissionsToRender(data.data);
        
        // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
    } catch (error) {
        console.error('Failed to fetch jobs:', error);
    }
    finally {

      // callback({refreshData: true})
      // router.refresh()
        // setDataGridDataLoading(false)
    }



    /*---------------------------------------
      GET updated submission event
    ---------------------------------------*/
    // try {
    //     const response = await fetch(`${baseUrl}/api/submissions/${submissionData.relation_uuid}?user_type=${user.user_type}`, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': '*/*',
    //             'Content-Type': 'application/json'
    //         },
    //         credentials: 'include', // Necessary for cookies if API is on the same domain
    //     });
    //     if (!response.ok) {
    //         throw new Error('Network response was not ok');
    //     }
    //     const data = await response.json();
    //     console.log("DATA@GETSUBMISSION", data)
    //     // setRecordsTable(data.data?.reverse());
    //     setSubmissionTarget(data.data);
    //     console.log("SUBTARGET", submissionTarget)
    //     // console.log("DATA@admin/page.js", data); // Log to see what the data looks like
    // } catch (error) {
    //     console.error('Failed to fetch jobs:', error);
    // }
    // finally {
    //     // setDataGridDataLoading(false)
    // }

       






  }


    // v1
    // const getUsers = async () => {
    //  // Assume the environment variable is set correctly in your environment configuration
    //  const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
    //  try {
    //      const response = await fetch(`${baseUrl}/api/users?user_type=${thisUser?.user_type}`, {
    //          method: 'GET',
    //          headers: {
    //              'Accept': '*/*',
    //              'Content-Type': 'application/json'
    //          },
    //          credentials: 'include', // Necessary for cookies if API is on the same domain
    //      });
    //      if (!response.ok) {
    //          throw new Error('Network response was not ok');
    //      }
    //      const data = await response.json();
    //     //  console.log("USERS", data)
    //     //  setEntitiesTable(data.data?.reverse());
    //     //  setEntitiesToRender(data.data);
    //     setUsersTable(data.data)
         
    //     //  console.log("DATA@admin/users/page.js", data); // Log to see what the data looks like
    //  } catch (error) {
    //      console.error('Failed to fetch jobs:', error);
    //  }
    // }


    // v2 claude
    const getUsers = async () => {
  const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';
  try {
    const response = await fetch(`${baseUrl}/api/users?user_type=${thisUser?.user_type}`, {
      method: 'GET',
      headers: { 'Accept': '*/*', 'Content-Type': 'application/json' },
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    setUsersTable(data.data)
    return data.data            // <-- new
  } catch (error) {
    console.error('Failed to fetch users:', error);
    return []
  }
}



    // chat:join is only called inside handleSend, so only the sender ever joins chat:<uuid>. A recipient sitting on the chat page never receives live messages. Because they're connected, they also wouldn't get a notification, so they'd see nothing until a refresh. In Chat.js, join whenever the active chat changes:


    useEffect(() => {
  if (connected && activeChat?.chat_uuid) {
    joinChat(activeChat.chat_uuid);
  }
}, [connected, activeChat?.chat_uuid]);



// v1
  // useEffect(() => {

  //  const init = async () => {

  //   if (activeChat?.new === true || activeChat === null) {
  //     setActiveChatParticipants([])
  //   }
  //   else {
  //     setActiveChatParticipants(activeChat?.participants)
  //   }
  //   setActiveChatUUID(activeChat?.chat_uuid)
  //   // setActiveChatParticipants(activeChat?.participants)
    
  
  //   const recipientsHandlesArr = activeChat?.participants?.map(p => p.user_handle)
  //   setRecipientsHandles(recipientsHandlesArr)
   

  //   await getUsers()
  //   // setConcatenatedMessages(activeChat?.messages?.concat(messages))
  //   // const allMessages = activeChat?.messages?.concat(messages)
  //   // await getChats()
  //  }

  //  init ()
  // }, [activeChat])
  


  // v2 claude
  useEffect(() => {
  const init = async () => {
    const users = await getUsers()

    if (activeChat?.new === true && activeChat.recipientHandle) {
      // new chat started from a profile: preselect the recipient
      const recipient = users?.find(u => u.user_handle === activeChat.recipientHandle)
      if (recipient) {
        setActiveChatParticipants([recipient])
        setRecipientsHandles([recipient.user_handle])
      } else {
        setActiveChatParticipants([])
        setRecipientsHandles([])
      }
      setActiveChatUUID(undefined)
      return
    }

    if (activeChat?.new === true || !activeChat) {
      setActiveChatParticipants([])
      setRecipientsHandles([])
    } else {
      setActiveChatParticipants(activeChat.participants)
      setRecipientsHandles(activeChat.participants?.map(p => p.user_handle) ?? [])
    }
    setActiveChatUUID(activeChat?.chat_uuid)
  }
  init()
}, [activeChat])

  const chatScrollRef = useRef(null);
  useEffect(() => {
    const el = chatScrollRef.current;
    if (!el) return;

    el.scrollTop = el.scrollHeight;
  }, [messages, activeChat?.messages]);
// const chatBottomRef = useRef(null)
  // Scroll when messages change
// useEffect(() => {
//   chatBottomRef.current?.scrollIntoView({
//     behavior: 'smooth' // or 'auto' if you prefer instant
//   });
// }, [messages]);
  



//   const handleSend = async () => {
//   if (!newMessage) return;

//   if (recipientsHandles.length < 1) {
//     setError({ message: 'Specify at least one recipient' });
//     return;
//   }

//   const dbResponse = await handleSubmit();
//   const chatUUID = dbResponse.chatUUID;

//   joinChat(chatUUID);

//   // ⏱ wait one tick so the room join completes
//   setTimeout(() => {
//     sendMessage({ chatUUID, msg: newMessage });
//   }, 0);

//   setNewMessage('');
// };

  const handleSend = async () => {

    if (!newMessage) return;
    if (recipientsHandles.length  < 1) {
      setError({message: 'Specify at least one recipient'})
      return;
    }

    let dbResponse = await handleSubmit({chat_uuid: activeChatUUID})
    setActiveChatUUID(dbResponse.chatUUID)
    joinChat(dbResponse.chatUUID);

    sendMessage({chatUUID: dbResponse.chatUUID, msg: newMessage});
    setNewMessage('');
    if (dbResponse.isNewChat === true) {
      console.log("GET NEW CHATS")
      callback({refreshData: true})
    }

  };


  const handleNewMessageCardCallback = e =>{ 
    console.log("Ev", e.newMessage)
    setNewMessage(e.newMessage)
  }



  const handleUserSelectCallback = cb => {

    console.log('cb@handleuserselect', cb)
        //  setRecipientsHandles(prev => [
        //   ...new Set([...prev, '...cb.selectedUsers?.newRecords[0]'])
        // ])
  if (cb.selectedUsers){
        let selectedUsersHandles = cb.selectedUsers.map(u=> u.user_handle)
        setRecipientsHandles(selectedUsersHandles)
        callback({selectedUsers: cb.selectedUsers})
      }
  }


  const handleMessageChange = e => {
    setCharCount(e.target.value?.length) // -replyToHandle.length
      if (e.target.value?.length >= CHAR_LIMIT) { // +replyToHandle.length
        setCharLimitError({message: 'Character limit exceeded'})
      }
      else {
        setCharLimitError(false)
      }
    setNewMessage(e.target.value)
 
  }

  return (
    <div>
      {/* <h2>Chat {connected ? '(Connected)' : '(Disconnected)'}</h2> */}
















<div className="h-screen flex flex-col">

  {/* Sticky header */}
  
    <div className={`px-2 dark:text-slate-400 sticky top-16 z-30 bg-slate-50 dark:bg-slate-800 border-b dark:border-slate-700 opacity-95 flex justify-between min-h-16 flex items-center py-2 gap-4`}>
      <Link
        href="?"
        className="flex items-center flex gap-4 sm:hidden"
      >
          <div className="hover:text-teal-400 transition-all duration-150 rounded-full h-10 w-10 bg-slate-100 dark:bg-slate-700 flex items-center justify-center">
        <i className="text-base fa-solid fa-arrow-left-long" />
        </div>
          {/* <NewRecordButton caption={null} shadow={'shadow-lg'} icon={'fa-solid fa-arrow-left-long'}/> */}
        {/* <span className="text-lg">Feed</span> */}
      </Link>




      {/* <div className="hidden text-sm 2xl:flex items-center">
        <h1>
        {'CHAT TITLE'}
        </h1>
      </div> */}


      <div className="flex-1 gap-1 items-center">

      <UserSelect 
      followedByMe={followedByMe}
      followsMe={followsMe}
      thisUser={thisUser}
            // key={activeChatUUID}
      presetUsers={activeChatParticipants}
     isMulti={false} 
     tagsTable={usersTable} 
     callback={handleUserSelectCallback} 
    //  tagsLevel={1} 
     target={activeChat} 
     placeholder={"Start typing a member's handle or name.."} 
     selectedParent={'data.talent_sector_industry?.id'}
     />

      

    </div>
    </div>
  



  {/* SCROLL CONTAINER (header must be inside this parent) */}
  <div ref={chatScrollRef} className="flex-1 overflow-y-auto overflow-x-hidden">
    {/* {editingPost ? <NewSocialPostCard
      ref={textareaRef}
        user={user}
        isComment
        replyToUUID={replyToUUID}
        parentPost={post}
        replyToHandle={replyToHandle}
        target={post}

      /> : 
    <SocialPostSmallCard cardIsClickable={mainSocialPostCardIsClickable} callback={focusTextarea} data={post} user={user} parentComponent={mode === 'MODAL' ? 'THREAD' : 'PAGE'} />
} */}




{/* content */}
      <div  className ={`h-full`}
      // style={{ height: '100%', overflowY: 'scroll', border: '1px solid #ccc', padding: '8px' }}
      >


<div className="py-20 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap flex gap-2 flex-col px-2">
           
            {/* {formatSocialPostBody(data.event_message_content)} */}
                    {/* from db */}
                    {activeChat?.messages?.map((msg, idx) => (
            
          <div className={`min-w-64 max-w-96 rounded-2xl px-4 py-2 ${msg.sender_user_uuid === thisUser.user_uuid ? 'text-white bg-blue-500 self-end' : 'bg-slate-100 dark:bg-slate-700 self-start'}`} key={idx}>{msg?.chat_message_content}

          <div className=''>
            {/* ilias */}
          </div>
          <div className='text-right w-full' style={{fontSize:'0.6rem'}}>{
          
          dateFormat_4 (msg.created_date)
          }</div>
        
          </div>
        ))}


        {/* from socket */}
        {messages
        .filter(msg => msg.chatUUID === activeChat?.chat_uuid)
        .map((msg, idx) => 
          // <div key={idx}>{msg?.text}</div>
          // msg.chatUUID === activeChat.chat_uuid && 
           {return (<div id={idx} className={`min-w-64 max-w-96 rounded-2xl px-4 py-2 ${msg.senderUserData.user_uuid === thisUser.user_uuid ? 'text-white bg-blue-500 self-end' : 'bg-slate-100 dark:bg-slate-700 self-start'}`} key={idx}>
              {msg?.text}
                    {console.log('CHATUUID', msg.chatUUID, activeChat.chat_uuid)}
          <div className=''>

              {/* <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} /> */}
          </div>
      {/* <div ref={chatBottomRef} /> */}

          <div className='text-right w-full' style={{fontSize:'0.6rem'}}>{
          dateFormat_2(msg.createdDate)
          
          // dateFormat_4 (msg.created_date)
          }</div>

          </div>)}

        )}
         
          </div>


      </div>



  </div>

  {/* Bottom input */}
  {(
    
     // can change this to fixed instead of sticky if breaks
    <div className={`border-t dark:border-slate-700 px-2 duration-300 py-4 bg-slate-50 dark:bg-slate-800 sticky bottom-0 w-full 
    `}>
      
      {thisUser && 
      
    <div className="relative w-full">
      {/* <TextAreaAutoGrow
        value={messageData.message_body}
        onChange={handleChange}
        /> */}

  <textarea
  onKeyDown={handleKeyDown}
    // rows={parentPost ? 1 : 3}
    rows ={2}
    placeholder={''}
    style={{ resize: 'none' }}
    className={`
      w-full
      p-4
      pb-14
      text-base
      font-inter
      ${'rounded'}
      bg-slate-100
      text-black
      dark:bg-slate-800
      dark:text-white
      dark:border
      dark:border-slate-700
      focus:outline-none
      dark:placeholder-slate-400
    `}
    name="message_body"
    id="message_body"
    onChange={(e) => handleMessageChange(e) }
    value={newMessage}
  />

  {/* Send button */}
  <div>

  <PlaneButton loading={loading} onClick={handleSend} caption={'Post'}/>
    <div className="absolute top-2 right-6 flex items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition">
      <p className={`text-xs mb-2 text-right ${charLimitError && 'text-red-500'} text-slate-300`}>{charCount}/{CHAR_LIMIT}</p>
    </div>
    </div>

</div>

    }

    </div>

  )}





 
</div>












            
    </div>
  );
}